import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-logo">
            <Link to="/">
              <img 
                src="https://i.postimg.cc/8PwKMkzR/Untitled-design-33-removebg-preview.png" 
                alt="Derma Protec Logo" 
              />
            </Link>
          </div>
          <p>Leading manufacturer of premium window films for automotive, architectural, skin and eye care sunblock film, and safety applications.</p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/faqs">FAQ</Link></li>
            <li><Link to="/become-distributor">Become a Distributor</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Products</h4>
          <ul>
            <li><Link to="/architectural">Architectural Solutions</Link></li>
            <li><Link to="/automotive">Automotive Solutions</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact Us</h4>
          <div className="contact-details">
            <p>Derma Protec Films HQ</p>
            <p>8 The Green, Dover, DE 19901, USA</p>
            <p><span role="img" aria-label="email">✉️</span> <a href="mailto:info@dermaprotecfilms.com">info@dermaprotecfilms.com</a></p>
            <p><span role="img" aria-label="phone">📞</span> <a href="tel:+13024935595">+1 (302) 493-5595</a></p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; {new Date().getFullYear()} Derma Protec Films. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 